export type DropmapProjectErrorCode =
  | 'archive-too-large'
  | 'file-read'
  | 'incomplete-project'
  | 'invalid-archive'
  | 'invalid-manifest'
  | 'invalid-project'
  | 'invalid-source'
  | 'invalid-symbol'
  | 'newer-version'
  | 'save-failed'
  | 'unsupported-source'
  | 'unsupported-version'
  | 'unsafe-entry-path'
  | 'wrong-format';

const USER_MESSAGES: Readonly<Record<DropmapProjectErrorCode, string>> = {
  'archive-too-large': 'This Placeio project is too large to open safely.',
  'file-read':
    'Placeio Maps could not read this project file. Check that it is available and try again.',
  'incomplete-project': 'The project file is incomplete or damaged.',
  'invalid-archive': 'This is not a valid Placeio project.',
  'invalid-manifest': 'This is not a valid Placeio project.',
  'invalid-project': 'The project file is incomplete or damaged.',
  'invalid-source': 'The project file contains invalid source data.',
  'invalid-symbol':
    'The project contains a missing, damaged or unsupported symbol. The current map is unchanged.',
  'newer-version': 'This project was created by a newer version of Placeio Maps.',
  'save-failed': 'Placeio Maps could not save this project. Try again.',
  'unsupported-source': 'This project contains a source type that this version cannot save.',
  'unsupported-version': 'This Placeio project version is not supported.',
  'unsafe-entry-path': 'This is not a valid Placeio project.',
  'wrong-format': 'This is not a valid Placeio project.',
};

export class DropmapProjectError extends Error {
  readonly userMessage: string;

  constructor(
    readonly code: DropmapProjectErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'DropmapProjectError';
    this.userMessage = USER_MESSAGES[code];
  }
}

export function asDropmapProjectError(error: unknown): DropmapProjectError {
  return error instanceof DropmapProjectError
    ? error
    : new DropmapProjectError('invalid-project', 'Unexpected project-file processing failure.');
}
